import { render, staticRenderFns } from "./checkusername.vue?vue&type=template&id=2ccaad98&"
import script from "./checkusername.vue?vue&type=script&lang=js&"
export * from "./checkusername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports